import { VirtualObjectsResponse } from '@spazious/dollhouse-graphql';
import { VirtualFurnitureReadAttributesAvailabilityStatusEnum } from '@spazious/react-backoffice';

import { RestApiClient } from '../context.js';

import { mapFurniture } from './mapFurniture.js';

export const getFurnitures = async (
  api: RestApiClient,
  spaceId: string,
  pageNumber: number
): Promise<VirtualObjectsResponse> => {
  const result = await api.diagramming.listDiagrammingVirtualFurnitures({
    pageNumber,
    pageSize: 100,
    filterVirtualMeetingRoom: spaceId,
    filterAvailabilityStatusIn: [VirtualFurnitureReadAttributesAvailabilityStatusEnum.Public].join(
      ','
    ),
  });

  return {
    data: result.data.data.map(mapFurniture),
    pagination: {
      hasNext: !!result.data.links?.next,
    },
  };
};
